import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { Button, ButtonProps, styled } from "@mui/material";

export const StyledButtonBase = styled(Button)(({ theme }) => ({
  px: 2.75,
  py: 1.5,
  color: "#fff",
}));

export const StyledLoadingButtonBase = styled(LoadingButton)(({ theme }) => ({
  px: 2.75,
  py: 1.5,
  color: "#fff",
}));

interface StyledButton {
  disabled: boolean;
}

export const StyledButton = (props: ButtonProps) => {
  return (
    <StyledButtonBase
      color="secondary"
      size="large"
      variant="contained"
      sx={{ color: "#fff" }}
      {...props}
    />
  );
};

export const StyledLoadingButton = (props: LoadingButtonProps) => {
  return (
    <StyledLoadingButtonBase
      {...props}
      color="secondary"
      size="large"
      type="submit"
      variant="contained"
      sx={{ color: "#fff" }}
    />
  );
};
